/** Shared load lifecycle for injectable schema stores (AC-37). */
export type SchemaStoreStatus = 'clear' | 'loading' | 'loaded' | 'error';

export interface SchemaStoreState<T> {
  status: SchemaStoreStatus;
  items: T[];
  error: unknown | null;
}

export function initialSchemaStoreState<T>(): SchemaStoreState<T> {
  return {status: 'clear', items: [], error: null};
}
